import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { BASEL_BODY_CLASSES, BASEL_HTML_CLASS, BASEL_PAGE_CLASSES } from './core/constants/basel';
import { LanguageService } from './core/i18n/language.service';
import { AdminChatSessionService } from './core/services/admin-chat-session.service';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { GlobalLoadingComponent } from './shared/components/global-loading/global-loading.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ConfirmDialogComponent, GlobalLoadingComponent],
  template: `
    <router-outlet />
    <app-confirm-dialog />
    <app-global-loading />
  `
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly _i18n = inject(LanguageService);
  /** Keep admin chat notifications alive across admin ↔ storefront. */
  private readonly _adminChat = inject(AdminChatSessionService);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.syncShell((event as NavigationEnd).urlAfterRedirects);
    });
    this.syncShell(this.router.url);
  }

  private syncShell(url: string): void {
    const path = url.split('?')[0];
    const isAdmin = path.startsWith('/login') || path.startsWith('/admin');
    document.body.classList.toggle('admin-app', isAdmin);
    if (isAdmin) {
      document.body.dataset['portal'] = environment.businessKey;
    } else {
      delete document.body.dataset['portal'];
    }
    document.documentElement.classList.toggle(BASEL_HTML_CLASS, !isAdmin);
    for (const cls of BASEL_BODY_CLASSES) {
      document.body.classList.toggle(cls, !isAdmin);
    }
    if (isAdmin) {
      document.body.classList.remove(...BASEL_PAGE_CLASSES);
    }
    document
      .querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"][href^="/basel/"]')
      .forEach((link) => {
        link.disabled = isAdmin;
      });
  }
}
